import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

export const initSentry = () => {
	if (process.env.NODE_ENV !== 'production') {
		return
	}
	Sentry.configureScope(scope => {
		scope.setExtra('NutstoreSDK-version-expected')
	})
	Sentry.init({
		dsn: 'https://f582fffd7c4d4148b8944478b8937978@sentry.jianguoyun.com/13',
		integrations: [
			new Integrations.Vue({
				Vue,
				attachProps: true,
			}),
		],
	})
}
